import React, { useEffect, useState, useCallback } from "react";
import "./AllQuizQuestionsTable.css";
import UserQuizQuestionsTable from "./UserQuizQuestionsTable/UserQuizQuestionsTable";
import PracQuizQuestionsTable from "./PracQuizQuestionsTable/PracQuizQuestionsTable";

function AllQuizQuestionsTable({ questions, fetchQuizQuestions, userData }) {
  const [selectedQuizType, setSelectedQuizType] = useState("user");
  const [createNewQuestion, setCreateNewQuestion] = useState(false);

  return (
    <div className="quiz-questions-table">
      <div className="table-header">
        <h3>Empathy Quiz Questions</h3>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "1rem",
        }}
      >
        <div className="radio-group" style={{ margin: 0 }}>
          <label
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <input
              type="radio"
              value="user"
              checked={selectedQuizType === "user"}
              onChange={() => setSelectedQuizType("user")}
            />
            User Quiz Questions
          </label>
          <label
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <input
              type="radio"
              value="prac"
              checked={selectedQuizType === "prac"}
              onChange={() => setSelectedQuizType("prac")}
            />
            Practitioner Quiz Questions
          </label>
        </div>
        <button onClick={() => setCreateNewQuestion(true)}>
          Create New Question
        </button>
      </div>

      {selectedQuizType === "user" ? (
        <UserQuizQuestionsTable
          questions={questions.filter((q) => q.quizType === selectedQuizType)}
          fetchQuizQuestions={fetchQuizQuestions}
          createNewQuestion={createNewQuestion}
          setCreateNewQuestion={setCreateNewQuestion}
          userData={userData}
        />
      ) : (
        <PracQuizQuestionsTable
          questions={questions.filter((q) => q.quizType === selectedQuizType)}
          fetchQuizQuestions={fetchQuizQuestions}
          createNewQuestion={createNewQuestion}
          setCreateNewQuestion={setCreateNewQuestion}
          userData={userData}
        />
      )}
    </div>
  );
}

export default AllQuizQuestionsTable;
